import React from "react"
import { Form } from "react-bootstrap"
import { blockingFetchService } from "../../../lib/blockingFetch"
import {
  CALCULATION_TYPE,
  glAccountsDataWithId,
  sortGLAccounts,
  validateAmountState,
  validatePercentState,
  validateTextState,
  VALIDATION_TYPE
} from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import FormControlInlineCheckbox from "../../fragments/FormControl.Inline.Checkbox"
import FormControlInlineInput from "../../fragments/FormControl.Inline.Input"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import FormControlInlineTextArea from "../../fragments/FormControl.Inline.TextArea"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { browserHistory } from "react-router"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import FormButtons from "../../fragments/FormButtons"

const CalculationTypes = [
  { value: CALCULATION_TYPE.FLAT, title: 'Flat' },
  { value: CALCULATION_TYPE.PERCENT, title: '% of Amount' },
]

class LoanCommissionForm extends React.Component {

  constructor(props) {

    super(props)
    const { loanCommission } = this.props,
    isNew = !loanCommission

    this.state = {
      isNew,
      running: false,
      success: false,
      error: null,
      name: isNew ? '' : loanCommission.name,
      accountToDebit: (isNew || !loanCommission.accountToDebit) ? '' : loanCommission.accountToDebit.id,
      accountToCredit: (isNew || !loanCommission.accountToCredit) ? '' : loanCommission.accountToCredit.id,
      description: isNew ? '' : loanCommission.description,
      disabled: isNew ? false : loanCommission.disabled,
      calculationType: isNew ? CALCULATION_TYPE.FLAT : loanCommission.calculationType,
      amount: isNew ? '' : loanCommission.amount,

      nameValidationState: VALIDATION_TYPE.NULL,
      accountToDebitValidationState: VALIDATION_TYPE.NULL,
      accountToCreditValidationState: VALIDATION_TYPE.NULL,
      descriptionValidationState: VALIDATION_TYPE.NULL,
      calculationTypeValidationState: VALIDATION_TYPE.NULL,
      amountValidationState: VALIDATION_TYPE.NULL,
    }
  }

  uri = '/loancommission'

  componentDidMount() {

    this.props.loadData()
    const { isNew } = this.state
    if(!isNew) {
      this.validateAllValues()
    }
  }

  nameChanged = name => this.setState({
    name,
    nameValidationState: validateTextState(name, false),
    error: null,
  })

  accountToDebitChanged = accountToDebit => this.setState({
    accountToDebit,
    accountToDebitValidationState: validateTextState(accountToDebit, false),
    error: null,
  })

  accountToCreditChanged = accountToCredit => this.setState({
    accountToCredit,
    accountToCreditValidationState: validateTextState(accountToCredit, false),
    error: null,
  })

  descriptionChanged = description => this.setState({
    description,
    descriptionValidationState: validateTextState(description, true),
    error: null,
  })

  validateAmount = (amount, calculationType) =>
    calculationType === CALCULATION_TYPE.FLAT
      ? validateAmountState(amount, false)
      : validatePercentState(amount, false)

  calculationTypeChanged = calculationType => {

    const { amount } = this.state,
    amountValidationState = amount
      ? this.validateAmount(amount, calculationType) 
      : VALIDATION_TYPE.NULL

    this.setState({
      calculationType,
      calculationTypeValidationState: validateTextState(calculationType, false),
      amountValidationState,
      error: null,
    })
  }

  amountChanged = amount => {

    const { calculationType } = this.state
    this.setState({
      amount,
      amountValidationState: this.validateAmount(amount, calculationType),
      error: null,
    })
  }

  disabledChanged = () => this.setState({
    disabled: !this.state.disabled
  })

  validateAllValues = () => {

    const { name, accountToDebit, accountToCredit, description, calculationType, amount } = this.state
    this.setState({
      nameValidationState: validateTextState(name, false),
      accountToDebitValidationState: validateTextState(accountToDebit, false),
      accountToCreditValidationState: validateTextState(accountToCredit, false),
      descriptionValidationState: validateTextState(description, true),
      calculationTypeValidationState: validateTextState(calculationType, false),
      amountValidationState: this.validateAmount(amount, calculationType),
    })
  }

  valid = () => {

    const { name, accountToDebit, accountToCredit, description, calculationType, amount } = this.state
    return (
      validateTextState(name, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(accountToDebit, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(accountToCredit, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(description, true) !== VALIDATION_TYPE.ERROR &&
      validateTextState(calculationType, false) === VALIDATION_TYPE.SUCCESS &&
      this.validateAmount(amount, calculationType) === VALIDATION_TYPE.SUCCESS
    )
  }

  saveClicked = () => {

    if(this.valid()) {
      this.saveData()
    }
    else {
      this.validateAllValues()
      this.setState({ error: 'Some fields are incorrect.' })
    }
  }

  saveData = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { isNew, name, accountToDebit, accountToCredit, description, calculationType,
      amount, disabled } = this.state,

    data = { name, accountToDebit: { id: accountToDebit }, accountToCredit: { id: accountToCredit },
      description, calculationType, amount, disabled
    },

    { loanCommission } = this.props

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.createLoanCommission(accessToken, data)
        : apiServerApi.updateLoanCommission(accessToken, loanCommission.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(() => browserHistory.push(this.uri), 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderForm = () => {

    const { isNew, error, success, running, name, accountToDebit, accountToCredit, description,
      amount, disabled, nameValidationState, accountToDebitValidationState, amountValidationState,
      accountToCreditValidationState, descriptionValidationState, calculationTypeValidationState,
      calculationType } = this.state,

    { glAccounts } = this.props,

    glAccountsData = glAccountsDataWithId(glAccounts)

    return (
      <div className="simple-form max-width-700 mx-auto mb-20">
        <Form horizontal onSubmit={e => { e.preventDefault(); this.saveClicked()}}>

          <h3 className="text-center">
            { isNew ? 'Add' : 'Update' } loan commission
          </h3>
          <hr />

          <FormControlInlineInput controlId="name" validationState={ nameValidationState }
            label='Name' placeholder='Enter name' value={ name }
            onChange={ this.nameChanged }
            helpText={ nameValidationState === VALIDATION_TYPE.ERROR ? 'Name is required' : '' }
          />

          <FormControlInlineSelect
            controlId='accountToDebit' validationState={ accountToDebitValidationState }
            label='Account to debit' value={ accountToDebit } 
            onChange={ this.accountToDebitChanged }
            options={ glAccountsData }
            withEmptyOption={ true }
            helpText={ accountToDebitValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
          />

          <FormControlInlineSelect
            controlId='accountToCredit' validationState={ accountToCreditValidationState }
            label='Account to credit' value={ accountToCredit } 
            onChange={ this.accountToCreditChanged }
            options={ glAccountsData }
            withEmptyOption={ true }
            helpText={ accountToCreditValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
          />

          <FormControlInlineSelect
            controlId='calculationType' validationState={ calculationTypeValidationState }
            label='Calculation type' value={ calculationType } 
            onChange={ this.calculationTypeChanged }
            options={ CalculationTypes }
          />

          <FormControlInlineInput controlId="amount" validationState={ amountValidationState }
            label={ `Amount ${ calculationType === CALCULATION_TYPE.FLAT ? '' : '(%)' }`} 
            placeholder={ calculationType === CALCULATION_TYPE.FLAT ? `amount` : '% of amount' }
            value={ amount } onChange={ this.amountChanged }
            helpText={ amountValidationState === VALIDATION_TYPE.ERROR ? 'Amount is incorrect!' : '' }
          />

          <FormControlInlineTextArea
            controlId='description' validationState={ descriptionValidationState }
            label='Description (Optional)' value={ description }
            onChange={ this.descriptionChanged }
          />

          <FormControlInlineCheckbox
            controlId='disabled' label='Disabled'
            validationState={ VALIDATION_TYPE.NULL } value={ disabled }
            onChange={ this.disabledChanged }
          />
        </Form>

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <FormButtons onSave={ this.saveClicked } 
          onCancel={() => browserHistory.push(this.uri)} 
          running={ running }
        />
      </div>
    )
  }

  render() {

    const { isNew } = this.state,
    dataBreadCrumbs = [
      { url: '/accounting', title: 'Accounting' },
      { url: this.uri, title: 'Loan commissions' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ dataBreadCrumbs } />
        { this.renderForm() }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  sortGLAccounts(glAccounts)
  return { glAccounts }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoanCommissionForm)



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/Form.js